import onboardingApi from './onboardingApi';
import { LogTourEventPayload } from './types';

// Logs a walkthrough event. Fire-and-forget friendly: returns true on success,
// false on any failure (logged, never thrown), so a logging hiccup can never
// break the walkthrough or the host app.
const logTourEvent = async (
  payload: LogTourEventPayload,
): Promise<boolean> => {
  try {
    const { data } = await onboardingApi.post('/log', payload);
    return data?.data?.ok === true;
  } catch (error) {
    console.error('[logTourEvent] Failed:', error);
    return false;
  }
};

export default logTourEvent;
